import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  TableContainer,
  Typography,
} from "@mui/material";
import _ from "lodash";
import React, { useContext, useEffect, useState } from "react";
import exportFromJSON from "export-from-json";
import {
  flexBetweenWithItemsCenter,
  flexCenter,
  itemsCenter,
  textEllipses,
} from "../../utilities/commonStyles/commonStyles";
import { months } from "../../utilities/const/const";
import {
  fetchHistoricalStudentAdmissionsData,
  fetchStudentAdmissionsData,
  getAllClassAttendance,
  getLessons,
} from "../../utilities/const/functions";
import { AuthContext } from "../../utilities/context/AuthContext";
import classes from "./AllAttendanceReport.module.css";
import StudentRow from "./StudentRow";
import InfoPopup from "./InfoPopup";
import { ExcelIcon } from "../../utilities/icons/icons";
import { flexBetweenCenter } from "../../utilities/commonStyles/commonStyles";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
export const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export const modules = ["Term 1", "Term 2", "Term 3", "Term 4"];
// let month = months;

export default function HistoricalAllAttendanceClassTable({
  searchValue,
  classData,
  getTeacherName,
  getLevelName,
}) {
  const [pageModules, setPageModules] = useState([]);
  const [module, setModule] = useState(0);
  const [month, setMonth] = useState(months);
  const [attendanceInfo, setAttendanceInfo] = useState([]);
  const [students, setStudents] = useState([]);
  const [lessons, setLessons] = useState([]);
  const { setLoading } = useContext(AuthContext);
  // const [attData, setAttData] = useState([]);
  const [add, setAdd] = useState(false);
  const handleChange = (event) => {
    const { value } = event.target;
    setModule(value);
  };

  // const getModuleName = (module) => {
  //   try {
  //     // classData[`module${module}`];
  //     console.log(classData[`module${module + 1}`]);
  //   } catch (error) {}
  // };

  const fetchClassAttendance = async () => {
    try {
      if (!classData) {
        return;
      }
      setLoading(true);
      setAttendanceInfo([]);
      setStudents([]);
      const res = await getAllClassAttendance(
        classData.id,
        classData.intakeMonth + module * 3,
        classData.intakeYear
      );
      const lessonRes = await getLessons(classData.id);
      const studentData = await fetchHistoricalStudentAdmissionsData(
        classData.id
      );
      setLessons(lessonRes?.data ?? []);
      // console.log({ studentData });
      //   console.log({ res });
      if (!res.error && !studentData.error) {
        // console.log({ data: res?.data });
        setStudents(studentData?.data ?? []);
        // setAttData(res?.data ?? []);
        const studentsGroup = _.groupBy(res?.data ?? [], "studentId");
        // const lessonsGroup = _.groupBy(res?.data ?? [], "lessonId");
        // console.log({ studentsGroup });
        // console.log({ lessonsGroup });
        setAttendanceInfo(studentsGroup);
        // let tmpArr = new Array(12).fill("");

        // console.log(Object.keys(lessonsGroup));
        // console.log({ intake: classData.intakeMonth });

        // let lessonRes = Object.keys(lessonsGroup).sort();
        // // console.log({ lessonRes });
        // lessonRes.forEach((e) => {
        //   let t = lessonsGroup[e][0];
        //   // console.log({ t });
        //   let d = new Date(t?.date?.seconds * 1000);
        //   var date = d.getDate();
        //   var day = d.getDay();
        //   var weekOfMonth = Math.ceil((date - 1 - day) / 7);
        //   // console.log({ date: d.toDateString() });
        //   // console.log(d.getMonth(), " ", weekOfMonth);
        //   let passedWeek = ((d.getMonth() - classData.intakeMonth) % 3) * 4;
        //   // let passedWeek = (d.getMonth() % 3) * 4;
        //   let position = passedWeek + (weekOfMonth % 4);
        //   // console.log({ position });
        //   tmpArr[position] = e;
        // });

        // setLessons(lessonRes);
        // setStudents(Object.keys(studentsGroup) ?? []);
      } else {
        window.alert(res.message);
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
      console.log(e);
    }
  };

  useEffect(() => {
    let modify = [...months];
    for (let index = 0; index < classData.intakeMonth; index++) {
      modify.push(modify.shift());
    }
    setMonth(modify);
    let abc = ["TERM -", "TERM -", "TERM -", "TERM -"];
    let m1 = abc[0] + " " + modify[0].toString().slice(0, 3);
    let m2 = abc[1] + " " + modify[3].toString().slice(0, 3);
    let m3 = abc[2] + " " + modify[6].toString().slice(0, 3);
    let m4 = abc[3] + " " + modify[9].toString().slice(0, 3);
    setPageModules([m1, m2, m3, m4]);
  }, [classData]);

  const handleExportToExcel = async () => {
    try {
      setLoading(true);
      const res = await getAllClassAttendance(
        classData.id,
        classData.intakeMonth,
        classData.intakeYear
      );
      const fileName = `${classData.classCode}` + new Date().toDateString();
      const exportType = "xls";
      const data = res?.data?.map((e) => {
        let presentStatus = e.replacementStatus
          ? "R"
          : e.presentStatus
          ? "P"
          : "A";
        let date = new Date(e?.date?.seconds * 1000);
        return {
          "Class ID": e.classId,
          "Student ID": e.studentId,
          "Lesson ID": e.lessonId,
          "Attendance Status": presentStatus,
          Date: `${date.getMonth()}-${date.getDate()}-${date.getFullYear()}`,
          Message: e.message,
        };
      });
      exportFromJSON({ data, fileName, exportType });
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  useEffect(() => {
    fetchClassAttendance();
  }, [module, add]);

  return (
    <Box
      sx={{
        width: "100%",
        backgroundColor: "#fff",
        borderRadius: "20px",
        padding: "10px 20px",
        mb: 3,
      }}
      key={classData.id}
    >
      {/* {divData} */}
      {/* {JSON.stringify(attendanceInfo)} */}
      <Box sx={flexBetweenCenter}>
        <Typography
          sx={{
            fontSize: "18px",
            color: (theme) => theme.palette.primary.main,
          }}
        >
          {classData.classCode}
        </Typography>
        <Box>
          <Button
            onClick={handleExportToExcel}
            sx={{
              ...flexCenter,
              width: "200px",
              gap: "5px",
              color: (theme) => theme.palette.primary.main,
              backgroundColor: "transparent",
              border: "1px solid #E6007E",
              padding: "5px 10px",
              "&:hover": { backgroundColor: "transparent" },
            }}
          >
            <ExcelIcon />
            Export to Excel
          </Button>
        </Box>
      </Box>
      <Box sx={{ ...flexBetweenWithItemsCenter, gap: "30px", mt: 2, mb: 2 }}>
        <Box sx={{ ...itemsCenter, gap: "100px" }}>
          <Box>
            <Box sx={{ ...itemsCenter, gap: "10px" }}>
              <Box sx={{ width: "50px" }}>Intake: </Box>
              <Box>
                {months[classData.intakeMonth]} {classData.intakeYear}
              </Box>
            </Box>
            <Box sx={{ ...itemsCenter, gap: "10px" }}>
              <Box sx={{ width: "50px" }}>Level: </Box>
              <Box>{getLevelName(classData?.level)}</Box>
            </Box>
          </Box>
          <Box>
            <Box sx={{ ...itemsCenter, gap: "10px" }}>
              <Box sx={{ width: "100px" }}>Class Time: </Box>
              <Box>
                {/* {classData.classTimeFrom == 2
                  ? "2:00 - 3:30PM"
                  : "4:00 - 5:30PM"} */}
                {classData.classTimeFrom}
              </Box>
            </Box>
            <Box sx={{ ...itemsCenter, gap: "10px" }}>
              <Box sx={{ width: "100px" }}>Teacher:</Box>
              <Box> {getTeacherName(classData?.teacher)}</Box>
            </Box>
          </Box>
        </Box>
        <Box sx={{ ...flexBetweenWithItemsCenter, gap: "10px" }}>
          <Box
            sx={{
              ...itemsCenter,
              gap: "10px",
              fontSize: "16px",
              ...textEllipses,
            }}
          >
            {classData[`module${module + 1}`] ?? ""}
          </Box>
          <Box>
            <FormControl sx={{ width: 300 }}>
              <InputLabel id="demo-multiple-checkbox-label">TERM</InputLabel>
              <Select
                value={module}
                onChange={handleChange}
                MenuProps={MenuProps}
                input={<OutlinedInput label="TERM" />}
              >
                <MenuItem disabled value="" defaultChecked>
                  Select Term
                </MenuItem>
                {pageModules.map((name, index) => (
                  <MenuItem key={name} value={index}>
                    {name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        </Box>
      </Box>
      <TableContainer
        sx={{
          // width: "100%",
          minHeight: "10vh",
          maxHeight: "60vh",
          borderRadius: "15px",
          overflowX: "scroll",
        }}
      >
        <table style={{ marginTop: "0px" }} className={classes.tableMain}>
          <thead>
            <tr style={{ width: "100%" }}>
              <th
                rowSpan={2}
                style={{
                  width: "60px",
                  maxWidth: "60px",
                  ...textEllipses,
                }}
                className={classes.info}
              >
                No.
              </th>
              <th
                rowSpan={2}
                style={{
                  width: "90px",
                  maxWidth: "90px",
                }}
                className={classes.info}
              >
                ID
              </th>
              <th
                rowSpan={2}
                style={{
                  width: "250px",
                  maxWidth: "250px",
                }}
                className={classes.info}
              >
                Name
              </th>
              <th
                rowSpan={2}
                style={{
                  width: "100px",
                  maxWidth: "100px",
                }}
                className={classes.info}
              >
                Message
              </th>
              {month.slice(3 * module, 3 * (module + 1)).map((e) => (
                <th key={e} colSpan={4} className={classes.months}>
                  {e}
                </th>
              ))}
            </tr>
            <tr style={{ width: "50%" }}>
              {/* .slice(module * 3 * 4, (module + 1) * 3 * 4) */}
              {lessons
                ?.slice(module * 3 * 4, (module + 1) * 3 * 4)
                .map((e, index) => (
                  <InfoPopup key={e.id} e={e} />
                  // <th key={e.id} className={classes.info} title={e.name}>
                  //   {/* {`L${index + 1}`} */}
                  //   {e.id}
                  // </th>
                ))}
            </tr>
          </thead>
          <tbody>
            {/* {console.log({ students })} */}
            {students
              ?.filter((a) =>
                a.id.toLowerCase().includes(searchValue.toLowerCase())
              )
              .filter((a, b) => {
                if (a?.dropped) {
                  return false;
                }
                return true;
              })
              .sort((a, b) => {
                // console.log({ a: a.id });
                // console.log({ b: b.id });
                return a.id > b.id ? -1 : 1;
              })

              .map((item, index) => (
                <StudentRow
                  index={index}
                  data={item}
                  lessons={lessons}
                  classData={classData}
                  fetchAtt={setAdd}
                  key={index}
                  module={module}
                  studentId={item.id}
                  attendanceData={attendanceInfo[item.id] ?? []}
                />
              ))}
          </tbody>
          <tbody>
            {/* {console.log({ students })} */}
            {students
              ?.filter((a) =>
                a.id.toLowerCase().includes(searchValue.toLowerCase())
              )
              .filter((a, b) => {
                if (a?.dropped) {
                  return true;
                }
                return false;
              })
              .sort((a, b) => {
                // console.log({ a: a.id });
                // console.log({ b: b.id });
                return a.id > b.id ? -1 : 1;
              })

              .map((item, index) => (
                <StudentRow
                  index={index}
                  data={item}
                  lessons={lessons}
                  classData={classData}
                  fetchAtt={setAdd}
                  key={index}
                  module={module}
                  studentId={item.id}
                  attendanceData={attendanceInfo[item.id] ?? []}
                />
              ))}
          </tbody>
        </table>
      </TableContainer>
      <Box
        sx={{
          ml: 2,
          mt: 4,
          ...itemsCenter,
          gap: "1%",
          fontSize: "12px",
        }}
      >
        <Box
          sx={{
            height: "20px",
            width: "20px",
            borderRadius: "50%",
            backgroundColor: "#FF8787",
          }}
        ></Box>
        SOS Students
      </Box>
      {/* <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          mt: "5px",
        }}
      >
        {students.length > 0 && (
          <Button
            sx={{
              color: "#4285F4",
              backgroundColor: "transparent",
              "&:hover": { backgroundColor: "transparent" },
            }}
          >
            See More
          </Button>
        )}
      </Box> */}
    </Box>
  );
}
